var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"btn-wrapper"},[(!_vm.disabled)?_vm._t("default"):_c('v-btn',{attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.disabledButtonText))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }